<template>
  <v-progress-circular
    :size="50"
    color="primary"
    indeterminate
  />
</template>

<script>
export default {
  name: 'BaseSpinner',
};
</script>
